import React from 'react';

import NavigationBar from 'components/navigation-bar/navigation-bar';

import Button from 'components/button/button';

import type { NavigationBarProps } from 'components/navigation-bar/navigation-bar';

import { useGetFreelancerDetails } from 'state/remote/remote-freelancer/use-get-freelancer-details';

import getLinks from './getLinks';

// the logo link is broken /dashboard/ so we patch it until it will be fixed.  ;)
const FreelancerNavBar: React.FC = () => {
  const { data, isLoading, error } = useGetFreelancerDetails();

  let links: NavigationBarProps = { links: [] } as NavigationBarProps;
  if (!isLoading && !error && data) links = getLinks(data?.verified || false);

  return (
    <>
      <NavigationBar {...links} className="w-full" variant="neutral" />
      <Button
        variant="outlined"
        type="button"
        label="patch"
        onClick={() => window.location.assign('/redirect_to_dashboard/')}
        className="absolute top-0 left-0 h-16 w-2/12 z-20 opacity-0"
      />
    </>
  );
};

export default FreelancerNavBar;
